module.exports = __webpack_public_path__ + "img/map_BG-mobile.75da8bcf.png";